module.exports = __webpack_public_path__ + "img/profil-active.4c94e6b9.svg";